<svelte:options customElement="clw-icon-betamount" />

<script lang="ts">
    export let fillColor = 'white';
</script>

<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2092_120571)">
        <path
            d="M11.9999 3.75C8.40125 3.75 5.3999 5.03618 5.3999 7.05C5.3999 9.06383 8.40125 10.35 11.9999 10.35C15.5986 10.35 18.5999 9.06383 18.5999 7.05C18.5999 5.03618 15.5986 3.75 11.9999 3.75ZM5.3999 10.0406V12C5.3999 14.0138 8.40125 15.3 11.9999 15.3C15.5986 15.3 18.5999 14.0138 18.5999 12V10.0406C17.1034 11.2699 14.7703 12 11.9999 12C9.22955 12 6.89645 11.2699 5.3999 10.0406ZM5.3999 14.9906V16.95C5.3999 18.9638 8.40125 20.25 11.9999 20.25C15.5986 20.25 18.5999 18.9638 18.5999 16.95V14.9906C17.1034 16.2199 14.7703 16.95 11.9999 16.95C9.22955 16.95 6.89645 16.2199 5.3999 14.9906Z"
            fill={fillColor}
        />
    </g>
    <defs>
        <clipPath id="clip0_2092_120571">
            <rect width="16.5" height="16.5" fill={fillColor} transform="translate(3.75 3.75)" />
        </clipPath>
    </defs>
</svg>
